import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { InputAdornment } from '@material-ui/core';
import { numberFormatter } from '@sprinx/formatting';
import FieldPreview from '../FieldPreview';
import useMuiFieldsContext from '../useMuiFieldsContext';
/**
 * Vypisuje value v procentech.
 */

var _ref2 = /*#__PURE__*/React.createElement(InputAdornment, {
  position: "end"
}, "%");

function PercentFieldPreview(_ref) {
  var pdp = _ref.decimalPrecision,
      value = _ref.value,
      other = _objectWithoutProperties(_ref, ["decimalPrecision", "value"]);

  var _useMuiFieldsContext = useMuiFieldsContext(),
      percentDecimalPrecision = _useMuiFieldsContext.percentDecimalPrecision;

  var decimalPrecision = pdp || percentDecimalPrecision;
  var displayValue = typeof value === 'number' ? numberFormatter(value * 100, decimalPrecision) : value;
  return /*#__PURE__*/React.createElement(FieldPreview, _extends({}, other, {
    value: displayValue,
    InputProps: {
      endAdornment: _ref2
    }
  }));
}

PercentFieldPreview.propTypes = {
  className: PropTypes.string,

  /**
   * Barva zobrazovane hodnoty.
   */
  color: PropTypes.oneOf(['initial', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary']),

  /**
   * Pocet desetinnych mist.
   * Pokud neni definovana pouzite se nastaveni z Provideru.
   */
  decimalPrecision: PropTypes.number,

  /**
   * `true` pokud se ma komponenta zobrazit v cele dostupne sirce.
   */
  fullWidth: PropTypes.bool,

  /**
   * Pomocny text, zobrazovany pod vstupem.
   */
  helperText: PropTypes.string,

  /**
   * Custom vlastnosti `Input`.
   */
  InputProps: PropTypes.shape({}),

  /**
   * Label fieldu.
   */
  label: PropTypes.string,
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  size: PropTypes.oneOf(['xsmall', 'small', 'normal', 'large']),
  style: PropTypes.shape({}),
  value: PropTypes.number
};
PercentFieldPreview.defaultProps = {
  className: undefined,
  color: undefined,
  decimalPrecision: undefined,
  fullWidth: false,
  helperText: undefined,
  InputProps: undefined,
  label: undefined,
  margin: undefined,
  size: undefined,
  style: undefined,
  value: undefined
};
export default PercentFieldPreview;